function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { rangeFromTo } from '@finect/front-utils/range';
var iicFields = {
  headlineFields: ['lastQuoteHeadline'],
  highlightFields: [{
    id: 'minInvestment'
  }, {
    id: 'performance',
    period: 'M36',
    type: 'annualized'
  }],
  tableFields: [{
    id: 'metadata',
    metadata: 'region'
  }, {
    id: 'metadata',
    metadata: 'index'
  }],
  headerFields: [{
    id: 'performance',
    period: 'M36',
    type: 'annualized',
    withSparkline: false,
    withPositiveSign: true,
    format: 'summary'
  }, 'managementFee'],
  mainFields: [{
    id: 'managementCompany',
    variant: 'link'
  }, {
    id: 'category',
    variant: 'link'
  }, 'isin', {
    id: 'classes',
    withModal: true
  }, {
    id: 'fee',
    fee: 'ogc'
  }, 'riskProfile', 'minInvestment', {
    id: 'TextESGRating',
    display: 'flex'
  }, {
    id: 'distributors',
    qty: 4,
    display: 'flex'
  }, {
    id: 'buyButton',
    variant: 'cta',
    withLabel: false,
    topMargin: true
  }],
  comparisonFields: [{
    id: 'distributors'
  }, {
    id: 'commission'
  }, {
    id: 'minInvestment',
    model: 'content'
  }, {
    id: 'performance',
    period: 'M36',
    type: 'annualized'
  }, {
    id: 'feature',
    feature: 'value-for-money'
  }, {
    id: 'feature',
    feature: 'cost'
  }],
  customizationFieldsStart: [{
    id: 'name',
    textAlign: 'left',
    withManagerIcon: true,
    withSPA: false
  }],
  customizationFieldsEnd: [{
    id: 'buyButton',
    variant: 'textButton',
    withLabel: false,
    topMargin: true
  }, {
    id: 'likeAction'
  }],
  customizationFields: [{
    title: 'Rentabilidades por períodos',
    fields: [{
      id: 'performance',
      period: 'M0'
    }, {
      id: 'performance',
      period: 'M12'
    }, {
      id: 'performance',
      period: 'M24'
    }, {
      id: 'performance',
      period: 'M36'
    }, {
      id: 'performance',
      period: 'M60'
    }, {
      id: 'performance',
      period: 'M120'
    }]
  }, {
    title: 'Rentabilidades por años',
    fields: rangeFromTo(new Date().getFullYear() - 5, new Date().getFullYear() - 1).map(function (year) {
      return {
        id: 'yearlyPerformance',
        year: year
      };
    })
  }, {
    title: 'Otras características',
    fields: [{
      id: 'metadata',
      metadata: 'region'
    }, {
      id: 'metadata',
      metadata: 'index'
    }, {
      id: 'metadata',
      metadata: 'topic'
    }, {
      id: 'minInvestment',
      model: 'content'
    }, {
      id: 'managementCompany',
      variant: 'link'
    }, {
      id: 'category',
      variant: 'link'
    }, {
      id: 'ESGRating',
      display: 'flex'
    }, 'benchmarks', 'indexed']
  }, {
    title: 'Comisiones',
    fields: ['lastQuote', {
      id: 'fee',
      fee: 'MGR'
    }, {
      id: 'fee',
      fee: 'SUC'
    }, {
      id: 'fee',
      fee: 'CUS'
    }, {
      id: 'fee',
      fee: 'OGC'
    }, {
      id: 'fee',
      fee: 'RED'
    }, {
      id: 'fee',
      fee: 'FLO'
    }]
  }, {
    title: 'Medidas estadísticas',
    fields: [{
      id: 'srri'
    }, {
      id: 'alpha',
      period: 'M12'
    }, {
      id: 'alpha',
      period: 'M36'
    }, {
      id: 'beta',
      period: 'M12'
    }, {
      id: 'beta',
      period: 'M36'
    }, {
      id: 'sharpeRatio',
      period: 'M12'
    }, {
      id: 'sharpeRatio',
      period: 'M36'
    }, {
      id: 'standardDeviation',
      period: 'M12'
    }, {
      id: 'standardDeviation',
      period: 'M36'
    }, {
      id: 'maxDrawdown',
      period: 'M12'
    }, {
      id: 'maxDrawdown',
      period: 'M36'
    }, {
      id: 'trackingError',
      period: 'M12'
    }, {
      id: 'informationRatio',
      period: 'M12'
    }]
  }, {
    title: 'Otras características',
    fields: ['totalNetAsset', 'classTotalNetAsset', {
      id: 'distributors'
    }, {
      id: 'finectRating'
    }, {
      id: 'feature',
      feature: 'value-for-money'
    }, {
      id: 'feature',
      feature: 'cost'
    }, {
      id: 'feature',
      feature: 'risk'
    }, {
      id: 'feature',
      feature: 'return'
    }, 'currency']
  }]
};
var mainCommonsFields = [{
  id: 'distributors',
  qty: 4,
  display: 'flex'
}, {
  id: 'buyButton',
  variant: 'cta',
  withLabel: false,
  topMargin: true
}];
var defaultHeaderFields = [{
  id: 'commission'
}];
var defaultHighlightFields = [{
  id: 'commission'
}, {
  id: 'minInvestment'
}];
var comparisonCommonsFields = [{
  id: 'finectRating'
}, {
  id: 'questions'
}, {
  id: 'reviews'
}, {
  id: 'feature',
  feature: 'cost'
}, {
  id: 'feature',
  feature: 'risk'
}];
export var fieldsByProductType = [_objectSpread({
  productType: 'fund'
}, iicFields), _objectSpread({
  productType: 'sicav'
}, iicFields), _objectSpread({
  productType: 'etf'
}, iicFields), _objectSpread({
  productType: 'plan'
}, iicFields), {
  productType: 'stock',
  highlightFields: defaultHighlightFields,
  headlineFields: [],
  headerFields: defaultHeaderFields,
  mainFields: [],
  comparisonFields: [{
    id: 'name',
    withManagerIcon: true,
    withSPA: false
  }, {
    id: 'distributors'
  }, {
    id: 'commission'
  }, {
    id: 'contentPerformance'
  }, {
    id: 'minInvestment',
    model: 'content'
  }, {
    id: 'feature',
    feature: 'cost'
  }]
}, {
  productType: 'deposit',
  highlightFields: [{
    id: 'apr'
  }, {
    id: 'minInvestment'
  }],
  headlineFields: ['apr'],
  headerFields: [{
    id: 'minInvestment'
  }, {
    id: 'termMonthsCount'
  }],
  mainFields: [{
    id: 'bank'
  }, {
    id: 'interest_rate'
  }, {
    id: 'minInvestment'
  }, {
    id: 'maxInvestment'
  }, {
    id: 'currency'
  }, {
    id: 'earlyTerminationEnabled'
  }, {
    id: 'originCountry'
  }, {
    id: 'countryCreditRating'
  }, {
    id: 'document'
  }].concat(mainCommonsFields),
  tableFields: [{
    id: 'bank'
  }, {
    id: 'interest_rate'
  }, {
    id: 'termMonthsCount'
  }, {
    id: 'apr'
  }, {
    id: 'minInvestment'
  }, {
    id: 'maxInvestment'
  }, {
    id: 'currency'
  }, {
    id: 'earlyTerminationEnabled'
  }, {
    id: 'originCountry'
  }, {
    id: 'countryCreditRating'
  }, {
    id: 'document'
  }],
  comparisonFields: [{
    id: 'bank'
  }, {
    id: 'interest_rate'
  }, {
    id: 'minInvestment'
  }, {
    id: 'maxInvestment'
  }, {
    id: 'currency'
  }, {
    id: 'earlyTerminationEnabled'
  }, {
    id: 'originCountry'
  }, {
    id: 'countryCreditRating'
  }, {
    id: 'document'
  }].concat(comparisonCommonsFields)
}, {
  productType: 'overnight-money',
  highlightFields: [{
    id: 'apr'
  }, {
    id: 'minInvestment'
  }],
  headlineFields: ['apr'],
  headerFields: [{
    id: 'minInvestment'
  }, {
    id: 'termMonthsCount'
  }],
  mainFields: [{
    id: 'bank'
  }, {
    id: 'interest_rate'
  }, {
    id: 'minInvestment'
  }, {
    id: 'maxInvestment'
  }, {
    id: 'currency'
  }, {
    id: 'earlyTerminationEnabled'
  }, {
    id: 'originCountry'
  }, {
    id: 'countryCreditRating'
  }, {
    id: 'document'
  }].concat(mainCommonsFields),
  tableFields: [{
    id: 'bank'
  }, {
    id: 'interest_rate'
  }, {
    id: 'termMonthsCount'
  }, {
    id: 'apr'
  }, {
    id: 'minInvestment'
  }, {
    id: 'maxInvestment'
  }, {
    id: 'currency'
  }, {
    id: 'earlyTerminationEnabled'
  }, {
    id: 'originCountry'
  }, {
    id: 'countryCreditRating'
  }, {
    id: 'document'
  }],
  comparisonFields: [{
    id: 'bank'
  }, {
    id: 'interest_rate'
  }, {
    id: 'minInvestment'
  }, {
    id: 'maxInvestment'
  }, {
    id: 'currency'
  }, {
    id: 'earlyTerminationEnabled'
  }, {
    id: 'originCountry'
  }, {
    id: 'countryCreditRating'
  }, {
    id: 'document'
  }].concat(comparisonCommonsFields)
}, {
  productType: 'roboadvisor',
  highlightFields: [{
    id: 'minInvestment'
  }],
  headlineFields: [{
    id: 'metadata',
    metadata: 'commission'
  }],
  headerFields: [{
    id: 'minInvestment'
  }],
  mainFields: [{
    id: 'metadata',
    metadata: 'minimum_subscription_amount'
  }, {
    id: 'metadata',
    metadata: 'strategy'
  }, {
    id: 'metadata',
    metadata: 'management_fee'
  }, {
    id: 'metadata',
    metadata: 'instruments_fee'
  }, {
    id: 'metadata',
    metadata: 'custodian'
  }].concat(mainCommonsFields),
  comparisonFields: [{
    id: 'commission'
  }, {
    id: 'minInvestment',
    model: 'content'
  }, {
    id: 'metadata',
    metadata: 'minimum_subscription_amount'
  }, {
    id: 'metadata',
    metadata: 'strategy'
  }, {
    id: 'metadata',
    metadata: 'pros'
  }, {
    id: 'metadata',
    metadata: 'cons'
  }, {
    id: 'metadata',
    metadata: 'mobile_app'
  }, {
    id: 'metadata',
    metadata: 'custodian'
  }].concat(comparisonCommonsFields)
}, {
  productType: 'managedaccount',
  highlightFields: [{
    id: 'commission'
  }, {
    id: 'minInvestment'
  }],
  headlineFields: [{
    id: 'commission'
  }],
  headerFields: defaultHeaderFields,
  mainFields: [{
    id: 'metadata',
    metadata: 'minimum_initial_subscription_amount'
  }, {
    id: 'metadata',
    metadata: 'management_fee'
  }, {
    id: 'metadata',
    metadata: 'management_success_fee'
  }, {
    id: 'feature',
    feature: 'cost'
  }].concat(mainCommonsFields),
  comparisonFields: [{
    id: 'commission'
  }, {
    id: 'minInvestment',
    model: 'content'
  }, {
    id: 'metadata',
    metadata: 'minimum_initial_subscription_amount'
  }, {
    id: 'metadata',
    metadata: 'management_fee'
  }, {
    id: 'metadata',
    metadata: 'management_success_fee'
  }, {
    id: 'metadata',
    metadata: 'pros'
  }, {
    id: 'metadata',
    metadata: 'cons'
  }, {
    id: 'metadata',
    metadata: 'buy_online'
  }, {
    id: 'metadata',
    metadata: 'mobile_app'
  }].concat(comparisonCommonsFields)
}, {
  productType: 'pias',
  highlightFields: defaultHighlightFields,
  headlineFields: [{
    id: 'commission'
  }],
  headerFields: [{
    id: 'apr'
  }, {
    id: 'minInvestment',
    model: 'content'
  }, {
    id: 'feature',
    feature: 'cost'
  }],
  mainFields: [].concat(mainCommonsFields),
  comparisonFields: [{
    id: 'apr'
  }, {
    id: 'minInvestment',
    model: 'content'
  }].concat(comparisonCommonsFields)
}, {
  productType: 'unitlink',
  highlightFields: defaultHighlightFields,
  headlineFields: [{
    id: 'commission'
  }],
  headerFields: [{
    id: 'minInvestment',
    model: 'content'
  }],
  mainFields: [].concat(mainCommonsFields),
  comparisonFields: [{
    id: 'commission'
  }, {
    id: 'minInvestment',
    model: 'content'
  }].concat(comparisonCommonsFields)
}, {
  productType: 'sialp',
  highlightFields: defaultHighlightFields,
  headlineFields: [{
    id: 'commission'
  }],
  headerFields: [{
    id: 'minInvestment'
  }],
  mainFields: [].concat(mainCommonsFields),
  comparisonFields: [{
    id: 'commission'
  }, {
    id: 'minInvestment',
    model: 'content'
  }].concat(comparisonCommonsFields)
}, {
  productType: 'service',
  highlightFields: defaultHighlightFields,
  headlineFields: [{
    id: 'commission'
  }],
  headerFields: [{
    id: 'commission'
  }, {
    id: 'minInvestment',
    model: 'content'
  }],
  mainFields: [].concat(mainCommonsFields),
  comparisonFields: [{
    id: 'commission'
  }, {
    id: 'minInvestment',
    model: 'content'
  }].concat(comparisonCommonsFields)
}, {
  productType: 'card',
  highlightFields: [{
    id: 'metadata',
    metadata: 'card_type'
  }, {
    id: 'metadata',
    metadata: 'card_company'
  }],
  headlineFields: [{
    id: 'metadata',
    metadata: 'card_type'
  }],
  headerFields: [{
    id: 'metadata',
    metadata: 'emission_comission'
  }],
  mainFields: [{
    id: 'metadata',
    metadata: 'card_type'
  }, {
    id: 'metadata',
    metadata: 'card_company'
  }].concat(mainCommonsFields),
  comparisonFields: [{
    id: 'metadata',
    metadata: 'card_type'
  }, {
    id: 'metadata',
    metadata: 'card_company'
  }, {
    id: 'metadata',
    metadata: 'emission_comission'
  }].concat(comparisonCommonsFields)
}, {
  productType: 'crypto',
  highlightFields: [{
    id: 'metadata',
    metadata: 'ranking'
  }],
  headlineFields: [{
    id: 'metadata',
    metadata: 'product'
  }],
  headerFields: [],
  mainFields: [].concat(mainCommonsFields),
  comparisonFields: [].concat(comparisonCommonsFields)
}, {
  productType: 'nft',
  highlightFields: defaultHighlightFields,
  headlineFields: [],
  headerFields: defaultHeaderFields,
  mainFields: [].concat(mainCommonsFields),
  comparisonCommonsFields: [].concat(comparisonCommonsFields)
}, {
  productType: 'token',
  highlightFields: [{
    id: 'metadata',
    metadata: 'sector'
  }, {
    id: 'metadata',
    metadata: 'expected_return'
  }],
  headlineFields: [{
    id: 'metadata',
    metadata: 'sector'
  }],
  headerFields: [{
    id: 'metadata',
    metadata: 'expected_return'
  }, {
    id: 'metadata',
    metadata: 'liquidity'
  }, {
    id: 'metadata',
    metadata: 'sector'
  }],
  mainFields: [].concat(mainCommonsFields),
  comparisonFields: [{
    id: 'metadata',
    metadata: 'expected_return'
  }, {
    id: 'metadata',
    metadata: 'liquidity'
  }, {
    id: 'metadata',
    metadata: 'sector'
  }].concat(comparisonCommonsFields)
}, {
  productType: 'wallet',
  highlightFields: [{
    id: 'metadata',
    metadata: 'protection'
  }, {
    id: 'metadata',
    metadata: 'format'
  }],
  headlineFields: [{
    id: 'metadata',
    metadata: 'format'
  }],
  headerFields: [{
    id: 'metadata',
    metadata: 'complexity'
  }, {
    id: 'metadata',
    metadata: 'format'
  }, {
    id: 'metadata',
    metadata: 'protection'
  }],
  mainFields: [].concat(mainCommonsFields),
  comparisonFields: [{
    id: 'metadata',
    metadata: 'complexity'
  }, {
    id: 'metadata',
    metadata: 'format'
  }, {
    id: 'metadata',
    metadata: 'protection'
  }].concat(comparisonCommonsFields)
}, {
  productType: 'savingsaccount',
  highlightFields: [{
    id: 'apr'
  }],
  headlineFields: [{
    id: 'metadata',
    metadata: 'apr'
  }],
  mainFields: [],
  comparisonFields: [{
    id: 'minInvestment',
    model: 'content'
  }].concat(comparisonCommonsFields)
}, {
  productType: 'course',
  highlightFields: [{
    id: 'metadata',
    metadata: 'method'
  }, {
    id: 'price'
  }],
  headlineFields: [{
    id: 'date',
    label: 'Fecha'
  }],
  headerFields: [{
    id: 'metadata',
    metadata: 'method'
  }, {
    id: 'cost',
    label: 'Precio',
    model: 'content'
  }, {
    id: 'metadata',
    metadata: 'duration'
  }],
  mainFields: [].concat(mainCommonsFields),
  comparisonFields: [{
    id: 'date',
    label: 'Fecha'
  }, {
    id: 'cost',
    label: 'Precio',
    model: 'content'
  }].concat(comparisonCommonsFields)
}, {
  productType: 'book',
  highlightFields: [{
    id: 'price'
  }],
  headlineFields: [{
    id: 'cost',
    label: 'Precio'
  }],
  headerFields: [{
    id: 'cost',
    label: 'Precio'
  }],
  mainFields: [{
    id: 'metadata',
    metadata: 'author'
  }].concat(mainCommonsFields),
  comparisonFields: [{
    id: 'cost',
    model: 'content',
    textAlign: 'left'
  }].concat(comparisonCommonsFields)
}, {
  productType: 'crowdfunding',
  highlightFields: [{
    id: 'minInvestment',
    model: 'content'
  }, {
    id: 'metadata',
    metadata: 'expected_return'
  }],
  headlineFields: [{
    id: 'minInvestment',
    model: 'content'
  }],
  headerFields: [{
    id: 'metadata',
    metadata: 'liquidity'
  }, {
    id: 'metadata',
    metadata: 'expected_return'
  }, {
    id: 'metadata',
    metadata: 'type'
  }],
  mainFields: [{
    id: 'metadata',
    metadata: 'country'
  }].concat(mainCommonsFields),
  comparisonFields: [{
    id: 'metadata',
    metadata: 'type'
  }, {
    id: 'metadata',
    metadata: 'liquidity'
  }, {
    id: 'metadata',
    metadata: 'expected_return'
  }, {
    id: 'metadata',
    metadata: 'country'
  }].concat(comparisonCommonsFields)
}];